export default __webpack_public_path__ + "static/media/more_vert-24px.5836aa97.svg";